import { splitString } from 'utils/splitString';

interface ICardHolder {
  value: string;
}

export const CardHolder = ({ value }: ICardHolder) => <div>{splitString(value, 4).join(' ')}</div>;
